// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__F0WQj","achievement":"Stats_achievement__TSlnK","circle":"Stats_circle__NISSO"};